import { FC } from "react";
import { IListLoadingElementProps } from "./types";

const ListLoadingElement: FC<IListLoadingElementProps> = ({ classNames }) => (
  <div className={`h-4 bg-grey rounded-full dark:bg-gray-700 ${classNames ? classNames : ""}`} />
);

export default ListLoadingElement;
